import React from 'react'
import { Button, FlexColumn, Icon } from 'elements'

export default function ChoiceButton({ selected, children, ...buttonProps }) {
  return (
    <Button
      justifyContent="space-between"
      flex="1"
      kind={selected ? 'alt-secondary' : 'normal'}
      {...buttonProps}
    >
      <FlexColumn
        flex="1"
        alignItems="flex-start"
        justifyContent="center"
        color={selected ? 'secondary.0' : 'neutral.1'}
      >
        {children}
      </FlexColumn>
      {selected ? <Icon name="check" size="small" mr="medium" color="secondary.0" /> : null}
    </Button>
  )
}
